// Schema definition for app state
// This file defines the structure and types of the global app state

const partIdentifierItemSchema = {
    type: 'object',
    properties: {
        id: { type: 'string' },
        item_number: { type: 'string' },
        item_name: { type: 'string' },
        item_id: { type: ['number', 'null'] },
        item_type: { type: 'string' },
        image_url: { type: ['string', 'null'] },
        score: { type: 'number' },
        category: { type: 'string' },
        external_sites: {
            type: 'array',
            default: [],
            itemSchema: { type: 'object' }
        },
        lookalikes: {
            type: 'array',
            default: [],
            itemSchema: { type: 'object' }
        },
        lots: {
            type: 'array',
            default: [],
            itemSchema: { type: 'object' }
        }
    }
};

export const appStateSchema = {
    title: {
        type: 'string',
        default: 'BrickBuddy',
        description: 'The current title displayed in the browser tab.'
    },
    isLoading: {
        type: 'boolean',
        default: false,
        description: 'Indicates if a global loading process is active.'
    },
    partIdentifier: {
        type: 'object',
        properties: {
            // Hidden until the user turns the tab on in User Settings.
            isHidden: {
                type: 'boolean',
                default: true,
                persist: true
            },
            identifiedItems: {
                type: 'object',
                properties: {
                    isLoading: {
                        type: 'boolean',
                        default: false
                    },
                    loadingItemKey: {
                        type: ['string', 'null'],
                        default: null
                    },
                    items: {
                        type: 'array',
                        default: [],
                        itemSchema: partIdentifierItemSchema
                    }
                }
            },
            selectedItem: {
                type: ['object', 'null'],
                default: null
            },
            filterText: {
                type: 'string',
                default: ''
            },
            sortOption: {
                type: 'string',
                default: 'itemNumber',
                enum: ['itemNumber', 'itemName']
            },
            webcamCapture: {
                type: 'object',
                properties: {
                    itemLookupType: {
                        type: 'string',
                        enum: ['PART', 'MINIFIG', 'SET'],
                        persist: true,
                        default: 'PART'
                    },
                    webcamState: {
                        type: 'object',
                        properties: {
                            stayActive: {
                                type: 'boolean',
                                persist: true,
                                default: true
                            },
                            selectedDevice: {
                                type: 'string',
                                persist: true,
                                default: ''
                            },
                            isScanning: {
                                type: 'boolean',
                                default: false
                            }
                        }
                    }
                }
            }
        }
    },
    pickListCompletionDialog: {
        type: 'object',
        properties: {
            isOpen: {
                type: 'boolean',
                default: false
            },
            itemType: {
                type: ['string', 'null'],
                default: null
            },
            name: {
                type: ['string', 'null'],
                default: null
            },
            number: {
                type: ['string', 'null'],
                default: null
            },
            trackedInUserSets: {
                type: 'array',
                default: [],
                description: 'User SET builds still needing the just-completed minifigure.',
                itemSchema: {
                    type: 'object',
                    properties: {
                        user_set_item_id: { type: 'number' },
                        user_set_id: { type: 'number' },
                        name: { type: 'string' },
                        number: { type: 'string' }
                    }
                }
            }
        }
    }
};
